import React, { useState } from 'react';
import { Alert, Button, Card, ListGroup } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAddressBook,
  faBuildings,
  faCircleInfo,
  faMask,
  faToolbox,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';

import { upgradeToProspecting } from 'bundles/connect/helpers/connect_api';

export default function UpgradePlanCard({ onUpgrade }) {
  const [upgrading, setUpgrading] = useState(false);

  const handleUpgrade = () => {
    setUpgrading(true);

    upgradeToProspecting()
      .then(onUpgrade)
      .catch(console.warn)
      .finally(() => setUpgrading(false));
  };

  return (
    <Card className="border-0 shadow" style={{ maxWidth: '400px' }}>
      <Card.Body className="d-flex flex-column gap-3">
        <div className="text-center">
          <FontAwesomeIcon className="text-accent" icon={faMask} size="2x" />
          <h3 className="my-0">Upgrade Your Account</h3>
        </div>
        You've ran out of credits to unmask property content for this month. To
        view this property's information please upgrade your account.
        <ListGroup className="py-3 border-top border-bottom">
          <ListGroup.Item className="border-0 px-0 pt-0 pb-2">
            <FontAwesomeIcon className="text-accent me-2" icon={faBuildings} />
            Property data across the country
          </ListGroup.Item>
          <ListGroup.Item className="border-0 px-0 pt-0 pb-2">
            <FontAwesomeIcon className="text-accent me-2" icon={faUsers} />
            Full demographic data
          </ListGroup.Item>
          <ListGroup.Item className="border-0 px-0 pt-0 pb-2">
            <FontAwesomeIcon
              className="text-accent me-2"
              icon={faAddressBook}
            />
            Enhanced owner data lookup
          </ListGroup.Item>
          <ListGroup.Item className="border-0 p-0">
            <FontAwesomeIcon className="text-accent me-2" icon={faToolbox} />
            Maximize your prospecting
          </ListGroup.Item>
        </ListGroup>
        <Alert className="d-flex gap-2 my-0" variant="info">
          <div>
            <FontAwesomeIcon icon={faCircleInfo} />
          </div>
          <p className="m-0">
            We'll use your current credit card saved to upgrade your
            subscription.
          </p>
        </Alert>
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <h6 className="mb-auto">$</h6>
            <h2 className="m-0 text-gradient">199</h2>
            <h5 className="mt-auto">/mo</h5>
          </div>
          <Button
            disabled={upgrading}
            variant="secondary"
            onClick={handleUpgrade}
          >
            Upgrade Now
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

UpgradePlanCard.propTypes = {
  onUpgrade: PropTypes.func.isRequired,
};
